export const defaultConfig = {
  facetDisplay: 'checkbox',
  facetLayout: 'list',
  selectionType: 'multi-select',
};

const department = {
  displayName: 'Department',
  facetDisplay: 'radio',
  facetLayout: 'list',
  selectionType: 'single-select',
  order: 1,
};

const style = {
  displayName: 'Category',
  facetDisplay: 'checkbox',
  facetLayout: 'list',
  selectionType: 'multi-select',
  order: 2,
};

const size = {
  displayName: 'Size',
  selectionType: 'size',
  order: 3,
};

const color = {
  displayName: 'Color',
  facetDisplay: 'swatch',
  facetLayout: 'grid',
  selectionType: 'multi-select',
  order: 4,
};

const price = {
  displayName: 'Price',
  order: 5,
};

const reviewScore = {
  displayName: 'Rating',
  facetDisplay: 'ratings',
  facetLayout: 'list',
  selectionType: 'single-select',
  order: 6,
};

const performanceTechnology = {
  displayName: 'Performance / Technology',
};

const activityOccasion = {
  displayName: 'Activity / Occasion',
};

const fabricMaterial = {
  displayName: 'Fabric / Material',
};

const newStyle = {
  hidden: true,
};

const config = {
  color,
  department,
  style,
  price,
  size,
  reviewScore,
  performanceTechnology,
  activityOccasion,
  fabricMaterial,
  newStyle,
};

export default config;
